import React, { useEffect, useState, memo } from 'react';
import moment from 'moment';
import { isEmpty, groupBy } from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import LinkIcon from '@material-ui/icons/Link';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import ModalDetailStat from 'components/general/ModalDetailStat';
import {
    HeaderCopy,
    HeaderTitle,
    HeaderAddress,
    OverviewDetails,
} from 'styles/form';
import StatusTag from 'components/StatusTag';
import {
    StickyHeader,
    Header,
    HeaderRight,
    MoreMenu,
    MoreMenuOption,
    Link,
} from './styles';
import ExportPdfModal from './ExportPdfModal';

const HeaderComponent = memo(
        ({
            orgName,
            statusTag,
            setStatusTag,
            toggleMoreMenu,
            moreMenuOpen,
            copySchedulerLink,
            link,
            bookedParticipants,
            hours,
            nursingHours,
            clinic,
            siteName,
            times,
            appointments,
        }) => {
            const [, setTitle] = useState('');
            const [address, setAddress] = useState('');
            const [exportModalOpen, setExportModalOpen] = useState(false);

            const groupedSlots = groupBy(times, ({ start_date: slotStartDate }) =>
                moment(slotStartDate, 'YYYY-MM-DD hh:mm:ss').format('MM-DD-YYYY'),
            );

            const handleModalOpen = () => {
                setExportModalOpen(true);
            };

            useEffect(() => {
                        if (clinic) {
                            const { sublocation } = clinic;
                            const {
                                nick_name: nickName,
                                room,
                                address: subLocationAddress,
                                city,
                                state,
                                postal_code: postalCode,
                                country,
                                is_virtual: isVirtual,
                            } = sublocation || {};

                            if (!isEmpty(sublocation)) {
                                setTitle(`${nickName}${room ? ` - ${room}` : ''}`);

          setAddress(
            isVirtual
              ? room
              : `${subLocationAddress}, ${city}, ${state}, ${postalCode}, ${country}`,
          );
        }
      }
    }, [clinic]);

    return (
      <StickyHeader>
        <ExportPdfModal
          slots={groupedSlots}
          exportModalOpen={exportModalOpen}
          setExportModalOpen={setExportModalOpen}
          appointments={appointments}
          clinic={clinic}
          siteName={siteName}
        />

        <Header>
          <HeaderCopy>
            <HeaderTitle>{siteName}</HeaderTitle>
            <HeaderAddress>{address}</HeaderAddress>
          </HeaderCopy>

          <HeaderRight>
            <StatusTag label={statusTag} setStatusTag={setStatusTag} />

            <IconButton component="span" onClick={toggleMoreMenu}>
              <MoreVertIcon />

              {moreMenuOpen && (
                <ClickAwayListener onClickAway={toggleMoreMenu}>
                  <MoreMenu>
                    <MoreMenuOption onClick={copySchedulerLink}>
                      <LinkIcon fontSize="sm" />
                      Copy Scheduler
                    </MoreMenuOption>

                    <Link href={link} target="_blank" rel="noreferrer">
                      <MoreMenuOption>
                        <OpenInNewIcon fontSize="sm" />
                        Open Scheduler
                      </MoreMenuOption>
                    </Link>

                    {statusTag !== 'Draft' && (
                      <MoreMenuOption onClick={handleModalOpen}>
                        <SaveAltIcon fontSize="sm" />
                        Export Appointments PDF
                      </MoreMenuOption>
                    )}
                  </MoreMenu>
                </ClickAwayListener>
              )}
            </IconButton>
          </HeaderRight>
        </Header>

        <OverviewDetails>
          <ModalDetailStat label="Organization" value={orgName} />
          <ModalDetailStat label="Hours" value={hours.toFixed(2)} />
          <ModalDetailStat
            label="Appointments Booked"
            value={bookedParticipants}
          />
          <ModalDetailStat
            label="Nursing Hours"
            value={nursingHours.toFixed(2)}
          />
        </OverviewDetails>
      </StickyHeader>
    );
  },
);

export default HeaderComponent;